export default __webpack_public_path__ + "static/media/londonmarathon.6c2f848d.jpg";